import { render, staticRenderFns } from "./GradientBlackRed.vue?vue&type=template&id=136abac8"
var script = {}
import style0 from "./GradientBlackRed.vue?vue&type=style&index=0&id=136abac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports